<template>
    <div>
        <div class="flex items-center space-x-6 -mr-1">
            <language />

            <div class="flex items-center py-1 sm:py-0 space-x-5">
                <div class="py-1.5 md:py-2 lg:py-2.5 text-center font-normal tracking-relaxed leading-snug text-white cursor-pointer select-none uppercase bg-blue-600 hover:bg-blue-500 transition-colors rounded-full flex-none"
                    :class="spanish || italian ? 'px-4 sm:px-3 md:px-4 lg:px-6 text-xs md:text-xs lg:text-sm' : 'px-6 sm:px-3 md:px-4 lg:px-8 text-xs md:text-sm lg:text-base'"
                    @click="show('signup-plans')"
                >
                    {{ $t('nav.signup') }}
                </div>

                <div class="py-1.5 md:py-2 lg:py-2.5 text-center font-normal tracking-relaxed leading-snug text-white cursor-pointer select-none uppercase bg-black hover:bg-blue-500 transition-colors rounded-full flex-none"
                    :class="spanish || italian ? 'px-4 sm:px-3 md:px-4 lg:px-6 text-xs md:text-xs lg:text-sm' : 'px-6 sm:px-3 md:px-4 lg:px-8 text-xs md:text-sm lg:text-base'"
                    @click="show_sign_in = true"
                >
                    {{ $t('nav.login') }}
                </div>
            </div>
        </div>

        <sign-in-modal
            :show="show_sign_in"
            @closed="signInClosed"
        >
            <slot />
        </sign-in-modal>
    </div>
</template>

<script>
import Language from '../nav/language.vue';
import SignInModal from './sign-in-modal.vue';
import { scrollIntoView } from 'scroll-js';

export default {
    components: {
        Language,
        SignInModal,
    },

    props: {
        on_home: { default: true },
        home_route: { default: '/' },
    },

    data() {
        return {
            show_sign_in: false,
            spanish: window.locale == 'sp',
            italian: window.locale == 'it',
        }
    },

    methods: {
        signInClosed() {
            this.show_sign_in = false;
        },
        scrollTo(id) {
            scrollIntoView(document.getElementById(id), document.body, {
                behavior: 'smooth',
            }).then(() => {
                // done scrolling document's body to show myElement
            });
        },
        show(section) {
            if (this.on_home || document.getElementById(section)) {
                this.scrollTo(section);
            } else {
                window.location = this.home_route + '#' + section;
            }
        },
    },
}
</script>
